import React from 'react'
import Overview from 'components/insightContent/visualization/Overview'
import { InsightContentSettingType } from 'components/insightContent/types'
import UnexpectedErrorBoundary from 'components/UnexpectedErrorBoundary'
import useCrosstabData from 'components/widget/CrosstabWidgets/share/Crosstab/useCrosstabData'
import Title from './Title'
import { resolveDifferenceOfAverage } from '../utils/averageResolver'
import selectEntireColumn from '../utils/columnSelector'
import selectEntireRow from '../utils/rowSelector'

const ColumnAverageDiff = ({
  detailSetting,
  widgetId,
  isAudienceQuery
}: {
  detailSetting: InsightContentSettingType
  widgetId: number
  isAudienceQuery: boolean
}) => {
  const { crossTabs } = useCrosstabData(widgetId, isAudienceQuery)

  const selectedColumn = selectEntireColumn(detailSetting, crossTabs)
  const selectedItem = selectEntireRow(detailSetting, selectedColumn)
  const differenceOfAverage = resolveDifferenceOfAverage(
    detailSetting,
    selectedColumn,
    selectedItem
  )

  return (
    <UnexpectedErrorBoundary>
      <Overview title={<Title />} count={differenceOfAverage} status="succeeded" />
    </UnexpectedErrorBoundary>
  )
}

export default ColumnAverageDiff
